
import CompetencyProvider from './CompetencyProvider';

export default class CompetencyService {
  constructor({ target, id }) {
    this.target = target;
    this.id = id;
  }

  async get(documentId, itemId) {
    if (itemId) {
      return CompetencyProvider.getCompetencyDocumentItem(itemId);
    }

    if (documentId) {
      return CompetencyProvider.getCompetencyDocument(documentId);
    }

    const targetId = (this.target && this.target.id) || this.id;
    if (targetId) {
      return CompetencyProvider.getCompetencyForCoursewareItem(targetId);
    }

    return undefined;
  }

  subscribe(documentId, itemId, callback) {
    if (callback) {
      this.get(documentId, itemId).then((items) => {
        callback(items);
      });
    }
    return () => { /* unsubscribe function */ };
  }

  static build(args) {
    return new CompetencyService(args);
  }
}
